import React from 'react';
import { Card, Container, Stack } from '@fiverr-private/layout_components';
import { Text, Typography } from '@fiverr-private/typography';
import { PlayCircleSolidL1Icon } from '@fiverr-private/visuals';
import { TextButton } from '@fiverr-private/button';
import { AppI18n, appTranslate } from '../../i18n';
import { briefCreationClickAction } from '../../monitoring/bqEvents';
import { Step } from '../../constants';
import { HowToModal } from '../HowToModal';
import { BriefCreationVariant } from '../../context/BriefCreationContext';

interface EducationBannerProps {
  currentStep: Step;
  contextId: string;
  source: string;
  variant: BriefCreationVariant;
  parentElement: string;
}

export const EducationBanner = ({ currentStep, contextId, source, variant, parentElement }: EducationBannerProps) => {
  const isOnboardingRouting = variant === 'onboarding_routing';

  const handleClick = () =>
    briefCreationClickAction({
      step: currentStep,
      action: 'how_does_it_work',
      briefContextId: contextId,
      eventSource: source,
      parentElement,
      variant,
    });

  if (isOnboardingRouting) {
    return (
      <Container width="fit-content">
        <HowToModal>
          <TextButton onClick={handleClick} type="button">
            <Container display="flex" gap="2" alignItems="center">
              <PlayCircleSolidL1Icon color="black" size="sm" />

              <Text size="b_sm" decoration="underline">
                {appTranslate('creation_step.onboarding.education_text')}
              </Text>
            </Container>
          </TextButton>
        </HowToModal>
      </Container>
    );
  }

  return (
    <Card padding="4" borderRadius="lg" backgroundColor="grey_200" borderColor="transparent" gap="4">
      <Stack color="grey_1200">
        <Text size="b_sm" color="inherit">
          <AppI18n
            k="education_banner"
            templates={{
              link: (text) => (
                <HowToModal>
                  <Typography onClick={handleClick} color="inherit" cursor="pointer" as="span" decoration="underline">
                    {text}
                  </Typography>
                </HowToModal>
              ),
            }}
          />
        </Text>
      </Stack>
    </Card>
  );
};
